import { types } from "mobx-state-tree";

import { MenuItems } from "../../../components/secondary-menu/SecondaryMenu";
import {
  ViewSewerObject,
  ViewSewerObjectFromAssignedProject,
} from "../../../services/authorization/Permissions";
import { permissionsService } from "../../../services/authorization/UserPermissionsService";

export enum NodeDynamicMenuItemsPages {
  EditNode,
}

export const NodeMenuItemsModel = types
  .model({
    nodeId: types.number,
    dynamicMenuItemPage: types.maybe(types.frozen<NodeDynamicMenuItemsPages>()),
    parentIdFromPath: types.number,
    shouldDisableMenuItems: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      getStaticMenuItems(): MenuItems {
        return {
          "general.general": {
            items: [
              {
                id: "secondary-menu-node-details",
                labelKey: "general.node.details",
                path: `/${self.parentIdFromPath}/sewer-objects/node/${self.nodeId}`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                isActive: self.dynamicMenuItemPage === NodeDynamicMenuItemsPages.EditNode,
                disabled: self.shouldDisableMenuItems,
              },
              {
                id: "secondary-menu-node-map",
                labelKey: "general.sewer-objects.map",
                path: `/${self.parentIdFromPath}/sewer-objects/node/${self.nodeId}/map`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                disabled: self.shouldDisableMenuItems,
              },
              {
                id: "secondary-menu-linked-objects",
                labelKey: "general.linked-objects",
                path: `/${self.parentIdFromPath}/sewer-objects/node/${self.nodeId}/linked-objects`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                disabled: self.shouldDisableMenuItems,
              },
            ],
            defaultOpen: true,
          },
        };
      },
    };
  });
